import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import { RECORD_ICONS } from 'javascripts/record_icons';

export class RecordTypeIcon extends Field {
  /**
   * All record types have an icon.
   */
  static availableForModel(modelClass, recordLayout) {
    return true;
  }

  get title() {
    return 'Record type icon';
  }

  get icon() {
    const { typename } = this.recordFields.modelClass;

    if (typename in RECORD_ICONS) {
      return RECORD_ICONS[typename];
    }

    throw new Error(`Missing icon for record type ${typename}`);
  }

  exampleContents(): FieldContentsData {
    return { icon: { name: this.icon, color: '#AAAAAA' } };
  }

  contentsForRecord(record): FieldContentsData {
    return { icon: { name: this.icon, color: '#AAAAAA' } };
  }
}
